
    /**
    * 获取操作记录列表
    **/
      
  import request, {AxiosPromise} from '@utils/request'
  export class IReqid14280 {
  /**
   * 主播accountNo
   */
  accountNo?: string | number;
  /**
   * 是否允许借样1-是允许，0-不允许
   */
  enableGetSample?: string | number;
  pageSize?: string | number;
  pageIndex?: string | number;
  rowId?: string | number;
  jumpType?: string | number;
  searchCount?: string | number;
  orderObjects?: string | number;
}
  /**
 * YResult<YListData<OperationRecordLogDTO>> :YResult
 */
export class IResid14280 {
  code?: {};
  msg?: {};
  success?: {};
  /**
   * YListData
   */
  data?: {
    /**
     * T
     */
    list?: {
      id?: {};
      /**
       * 操作人
       */
      operator?: {};
      /**
       * 操作类型1-是允许，0-不允许'
       */
      operateType?: {};
      /**
       * 操作原因
       */
      operateReason?: {};
      anchorName?: {};
      /**
       * 操作时间
       */
      operateTime?: {};
      isDeleted?: {};
      /**
       * 创建人
       */
      creator?: {};
      createTime?: {};
      /**
       * 修改人
       */
      updator?: {};
      updateTime?: {};
    }[];
    totalNumber?: {};
    totalPage?: {};
    rowId?: {};
  };
  exceptionMsg?: {};
}
  type Serve<T, G> = (data?: T) => AxiosPromise<G>
  const http: Serve<IReqid14280, IResid14280['data'] > = (data?) =>  request({
        method: 'GET',
        url: '/sampleReturnTimeout/getOperationRecord',
        params: data
      }) 
  export default http